const Home = () => import("@/views/home");
const Article = () => import("@/views/article");
const Debug = () => import("@/views/debug");
const Test = () => import("@/views/test");

const isDev = process.env.NODE_ENV === "development";

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      title: "请柬"
    }
  },
  {
    path: "/article",
    name: "article",
    component: Article,
    meta: {
      title: "文章"
    }
  },
  {
    path: "/debug",
    name: "debug",
    component: Debug,
    meta: {
      title: "调试"
    }
  }
];

// 开发环境引入测试页面
routes.push({
  path: "/test",
  name: "test",
  component: Test,
  meta: {
    title: "测试页面"
  }
});

// if (isDev) {

// }

routes.push({
  path: "*",
  redirect: { name: isDev ? "home" : "home" }
});

export default routes;
